import React from "react";
import { Col, Container, Row } from "react-bootstrap";
import {
  AndroidIcon,
  IphoneIcon,
  GameIcon,
  FlutterIcon,
  HealthcareIcon,
  ReactIcon,
} from "../../../app-constants";
import { Link } from "gatsby"; // Import Gatsby's Link component
import HtmlParser from "react-html-parser";

const StackItem = [
  {
    icon: AndroidIcon,
    title: "Android app development",
    description: (
      <>
        TekRevol is a Texas-based full-fledged Android app development company,
        expert in creating native Android apps that fully harness the potential
        of this technology. Android owns a massive share of users in the
        smartphone industry. Based on its popularity, our{" "}
        <Link
          to="/android-app-development"
          rel="noopener"
          aria-label="TekRevol"
        >
          Android app development services
        </Link>{" "}
        have helped startup founders and SMBs capitalize on the user base with
        native Android apps
      </>
    ),
  },
  {
    icon: IphoneIcon,
    title: "Iphone app development",
    description: (
      <>
        Embark on a journey of superiority with TekRevol's{" "}
        <Link to="/iphone-app-development" rel="noopener" aria-label="TekRevol">
          native iOS app development services.
        </Link>{" "}
        As a dominant player in iOS app development, we have developed some
        finest iPhone and iPad applications that have performed remarkably well
        on the App Store. Every detail is scrutinized with efficiency, ensuring
        your app pleasantly aligns with Apple's design principles and
        guidelines.
      </>
    ),
  },
  {
    icon: GameIcon,
    title: "Game app development",
    description: (
      <>
        Projections indicate that the gaming sector is poised to generate higher
        revenue compared to other leading segments within the entertainment
        industry. TekRevol's{" "}
        <Link to="/game-development" rel="noopener" aria-label="TekRevol">
          game development services
        </Link>{" "}
        are designed to create games that are future-proof, featuring impressive
        graphics, an exceptional player experience, and effective monetization
        strategies.
      </>
    ),
  },
  {
    icon: FlutterIcon,
    title: "Flutter app development",
    description: (
      <>
        Unlock the potential of feature-rich apps with TekRevol’s{" "}
        <Link
          to="/flutter-app-development"
          rel="noopener"
          aria-label="TekRevol"
        >
          Flutter development services.
        </Link>{" "}
        Our teams possess the power to deliver effective digital solutions for
        Android and iOS apps using Flutter. As a reputable mobile app
        development company in Texas, we are well aware of crafting the ideal
        flutter app tailored to your business needs
      </>
    ),
  },
  {
    icon: HealthcareIcon,
    title: "Healthcare app development",
    description: (
      <>
        Our{" "}
        <Link
          to="/healthcare-app-development"
          rel="noopener"
          aria-label="TekRevol"
        >
          healthcare app development services
        </Link>{" "}
        stand out in the competition by delivering efficiency. We have a proven
        record of success in the healthcare industry and specialize in the
        development of versatile healthcare apps. So, if you are looking forward
        to streamlining the complex processes of your healthcare business,
        TekRevol is your ultimate destination in Texas.
      </>
    ),
  },
  {
    icon: ReactIcon,
    title: "React Native app development",
    description:
      "Tekrevol utilizes the power of React Native to develop robust mobile apps for both Android and iOS platforms. The main goal is to deliver comprehensive functionality and a flawless experience. Our professional developers are dedicated to creating applications that not only match your needs but also offer a consistently next-level user experience across different operating systems.",
  },
];

function Improvise(props) {
  return (
    <div className="improvise_section p-100">
      <Container className="h-100">
        <Row className="h-100">
          <Col
            xs={12}
            md={12}
            lg={12}
            xl={10}
            xxl={4}
            className="m-xl-auto m-xxl-0"
          >
            <h2>Next-Gen Mobile App Development Services in Texas</h2>
            <p className="impro_para">
              We are your trusted{" "}
              <Link to="/mobile-app-development">
                mobile app development company
              </Link>{" "}
              in Texas offering an array of impeccable solutions to elevate your
              business. Work with our team of app developers in Texas and get
              game-changing tech solutions that are sustainable & scalable.
              Through careful fusion and creativity, we design diverse mobile
              app solutions that reflect your brand’s essence while providing
              flawless functionality.
            </p>
          </Col>
          <Col xs={12} md={12} lg={12} xl={12} xxl={8}>
            <div className="stack_box">
              {StackItem.map((item, index) => (
                <div className="stack_item" key={index}>
                  <div className="stack_title">
                    {item.icon}
                    <h5>{item.title}</h5>
                  </div>
                  <p>{item.description}</p>
                </div>
              ))}
            </div>
          </Col>
        </Row>
      </Container>
    </div>
  );
}

export default Improvise;
